import { toasterMsg } from '../../../Components/Toaster/Toaster';
import * as POTemplateConfigService from '../../../services/potemplate.service';
import type from './component.type';
import { ERROR_MESSAGE, imageUrl, downloadFile } from '../../../Components/helper';

export const fetchPOTemplateList = (reqObj) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.fetchPOTemplateList(reqObj);
    if (res?.code === 200) {
      await dispatch({
        type: type.FETCH_TEMPLATE_DETAILS,
        payload: res.data,
      });
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const deletePOTemplateList = (payload, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.deletePOTemplate(payload);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.PO_TEMPLATE_DELETE'}`);
      toasterMsg(msg, 'success');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: type.CLEAR_REDUCER_TEMPLATE,
    });
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const addPOTemplate = (payload, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.addNewPOTemplate(payload);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.ADD_PO_TEMPLATE'}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(res.data.errMsg);
      toasterMsg(msg, 'danger');
    }
    return res;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const fetchEditTemplate = (id, fromPO) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.fetchEditPOTemplate(id);
    if (res?.code === 200) {
      await dispatch({
        type: type.GET_EDIT_DATA,
        payload: res.data,
      });
      if (!fromPO) {
        toasterMsg('Po updated successfully', 'success');
      }
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const editPOTemplate = (id, payload, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.editPOTemplateData(id, payload);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.UPDATE_PO_TEMPLATE'}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return res;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const duplicatePOTemplate = (payload, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.duplicatePOTemplateData(payload);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.UPDATE_PO_TEMPLATE'}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return res;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const fetchPurchaseOrder = (reqObj) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.fetchPurchaseOrderList(reqObj);

    if (res?.code === 200) {
      await dispatch({
        type: type.FETCH_PURCHASE_ORDER,
        payload: res.data,
      });
    } else if (res?.code === 500) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res?.message, 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const deletePurchaseOrder = (id, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.deletePurchaseOrder(id);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.PO_TEMPLATE_DELETE'}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const downloadPdf = (id, req, transactionMsg) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.downloadPoPdf(id, req);
    if (res?.code === 200) {
      downloadFile(res.data?.zipUrl, 'component-order-po', 'pdf');
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.PDF_DOWNLOAD'}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const getProductAssociatesAction = () => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.getProductAssociates();
    if (res?.code === 200) {
      await dispatch({
        type: type.SUPPLIER_TYPE,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const getSupplierListBasedONType = (data) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.getSupplierList(data);
    if (res?.code === 200) {
      await dispatch({
        type: type.SUPPLIER_LIST,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const addPurachseOrder = (data, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.savePurchaseOrder(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.ADD_PURCHASE_ORDER'}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(res.data.errMsg);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const getPurchaseOrderById = (id) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.getPOById(id);
    if (res?.code === 200) {
      await dispatch({
        type: type.PURCHASE_ORDER_BY_ID,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const getPublicPurchaseOrderById = (id) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.getSupplierPOById(id);
    if (res?.code === 200) {
      await dispatch({
        type: type.PURCHASE_ORDER_BY_ID,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const fetchAllSupplier = () => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.getAllSupplierList();
    if (res?.code === 200) {
      await dispatch({
        type: type.SUPPLIER_LIST,
        payload: res.data,
      });
      return true;
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const saveEditPurchaseOrder = (id, data, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.saveEditPo(id, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.UPDATE_PURCHASE_ORDER'}`);
      toasterMsg(msg, 'success');

      return true;
    }
    if (res?.data?.errMsg) {
      const eMessage = res.data.errMsg?.includes("[ 'purchaseOrderNo must not be empty' ]") ? 'Purchase Order Number must not be empty' : res.data.errMsg;
      toasterMsg(transactionMsg(eMessage), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const fetchContactPersonList = () => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.getUserContactDetails();
    if (res?.code === 200) {
      await dispatch({
        type: type.CONTACT_USER_DATA,
        payload: res.data,
      });

      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const saveDuplicatePurachseOrder = (data, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.duplicatePurchaseOrder(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.ADD_PURCHASE_ORDER'}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      const errorMessage = res.data.errMsg.replace('Error: ', '');
      const eMessage = errorMessage?.includes("[ 'purchaseOrderId must not be empty' ]") ? 'Purchase Order Number must not be empty' : errorMessage;
      const msg = transactionMsg(eMessage);
      toasterMsg(msg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const cancelPurchaseOrder = (id, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.cancelPurchaseOrder(id);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.CANCEL_PURCHASE_ORDER'}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const SentEmailPurchaseOrder = (id, data, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.sendEmailPurchaseOrder(id, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.SEND_EMAIL_TO_SUPPLIER'}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const rejectApprove = (data, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.approveRejectPurchaseOrder(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.APPROVE_REJECT_PO'}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const fetchBomLibarayUnitOfMeasure = (data) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.getBomLibraryUnitOfMeasure(data);
    if (res?.code === 200 && res?.data) {
      return await dispatch({
        type: type.FETCH_UNIT_OF_MEASURE,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return Promise.resolve();
};

export const postPODocuments = (params, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.postPODocumentsService(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const fetchPurchaseOrderDocument = (id) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.getUploadedDocument(id);
    if (res?.code === 200) {
      await dispatch({
        type: type.FETCH_UPLOAD_DOCUMENTS,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const downloadPODoc = (data) => async () => {
  try {
    if (data?.filename) {
      const fileName = data.filename.toString();

      fetch(data?.path)
        .then((response) => response.blob()) // Convert response to a Blob
        .then((blob) => {
          const fileObjectURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = fileObjectURL;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileObjectURL); // Clean up
        })
        .catch((error) => console.error('Download error:', error));
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const putPurchaseOrderDocuments = (params, payload, transactionMsg) => async () => {
  try {
    const res = await POTemplateConfigService.editPurchaseDocument(params, payload);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const deletePODocuments = (params, id, transactionMsg, multi) => async () => {
  try {
    const res = await POTemplateConfigService.deletePODocument(params, id);
    if (res?.code === 200) {
      const msg = multi ? transactionMsg(`Component_Order.${'BACKEND_CONTROLLER.DELETE_PO_DOCUMENT'}`) : transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const getCreatedByUser = (pramams) => async (dispatch) => {
  try {
    const res = await POTemplateConfigService.getAllUsers(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: type.SET_CREATED_BY_USER,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const serveTheLocalFileFromServer = (path) => async () => {
  try {
    const res = await POTemplateConfigService.serveTheLocalFileFromServer(path);
    if (res) {
      return res;
    }
    console.log('resresres', res);
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
